import { Location, NavigateFunction } from 'react-router';
import { showErrorMessage } from '../components/Toaster';
import { mockUserToken } from '../Configuration';

enum Key {
  USER_TOKEN = 'USER_TOKEN',
}

const UNAUTHORIZED_PATH: string = '/unauthorized';

function setUserToken(token: string): void {
  localStorage.setItem(Key.USER_TOKEN, token);
}

function removeUserToken(): void {
  localStorage.removeItem(Key.USER_TOKEN);
}

function getUserToken(): string | null {
  return localStorage.getItem(Key.USER_TOKEN);
}

function redirectToUnauthorized(navigate?: NavigateFunction): void {
  if (navigate) {
    navigate(UNAUTHORIZED_PATH);
    return;
  }

  window.location.href = `${window.location.origin}${UNAUTHORIZED_PATH}`;
}

function extractUserToken(
  params: URLSearchParams,
  navigate: NavigateFunction,
): void {
  const userToken = params.get('userToken') || getUserToken();

  if (userToken) {
    setUserToken(userToken);
  } else {
    redirectToUnauthorized(navigate);
  }
}

function isUnauthorizedPath(location: Location): boolean {
  return location.pathname === UNAUTHORIZED_PATH;
}

function handleUnauthorized(message: string): void {
  removeUserToken();
  showErrorMessage(`Unauthorized: ${message}`);
  redirectToUnauthorized();
}

if (mockUserToken === 'true') {
  setUserToken('mock');
}

export {
  UNAUTHORIZED_PATH,
  getUserToken,
  extractUserToken,
  isUnauthorizedPath,
  handleUnauthorized,
};
